'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _memoizeStringOnly = require('./vendor/memoizeStringOnly');

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _RhumbContext = require('./internal/RhumbContext');

var _RhumbContext2 = _interopRequireDefault(_RhumbContext);

var _ActionTypes = require('./internal/ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _Constants = require('./internal/Constants');

var Constants = _interopRequireWildcard(_Constants);

var _ResultStatus = require('./internal/ResultStatus');

var ResultStatus = _interopRequireWildcard(_ResultStatus);

var _matchRoute = require('./internal/matchRoute');

var _matchRoute2 = _interopRequireDefault(_matchRoute);

var _consoleReporter = require('./internal/consoleReporter');

var _consoleReporter2 = _interopRequireDefault(_consoleReporter);

var _reaganCompatReporter = require('./internal/reaganCompatReporter');

var _ReporterActionTypes = require('./internal/ReporterActionTypes');

var ReporterActionTypes = _interopRequireWildcard(_ReporterActionTypes);

var _Scheduler = require('./internal/Scheduler');

var _performanceNow = require('./vendor/performanceNow');

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _legacyHubspotBenderContext = require('legacy-hubspot-bender-context');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};

var useInitial = function useInitial(initialValue) {
  var ref = (0, _react.useRef)(null);

  if (!ref.current) {
    ref.current = {
      value: initialValue()
    };
  }

  return ref.current.value;
};

var formatVersion = function formatVersion(version) {
  return version.startsWith('static-') ? version.substr(7) : 'dev';
};

var buildRouteSpecs = function buildRouteSpecs(partialRouteSpecs, defaultTimeout) {
  // eslint-disable-next-line no-undef
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(partialRouteSpecs, 'routeSpecs cannot be null');
  }
  // TODO devLogger warn deprecation
  var normalizeSuccess = function normalizeSuccess() {
    var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return Array.isArray(success) ? {
      default: success
    } : success;
  };

  return Object.keys(partialRouteSpecs).reduce(function (acc, route) {
    var routeSpec = partialRouteSpecs[route];
    var success = routeSpec.success,
        _routeSpec$error = routeSpec.error,
        error = _routeSpec$error === undefined ? [] : _routeSpec$error,
        _routeSpec$timeout = routeSpec.timeout,
        timeout = _routeSpec$timeout === undefined ? defaultTimeout : _routeSpec$timeout;


    acc[route] = {
      route: route,
      success: normalizeSuccess(success),
      error: error,
      timeout: timeout
    };
    return acc;
  }, {});
};

var buildGetRouteSpec = function buildGetRouteSpec(routeSpecs) {
  var routeKeys = Object.keys(routeSpecs);
  var routeMatcher = (0, _matchRoute2.default)(routeKeys);
  return (0, _memoizeStringOnly2.default)(function (pathname) {
    var route = routeKeys.find(function (key) {
      return routeMatcher(key, pathname);
    });

    return routeSpecs[route];
  });
};

var buildCheckStatus = function buildCheckStatus(getRouteSpec) {
  var checkStatusImpl = function checkStatusImpl(_ref) {
    var pathname = _ref.pathname,
        checks = _ref.checks,
        expiredTimestamp = _ref.expiredTimestamp;

    var routeSpec = getRouteSpec(pathname);
    // TODO DOCUMENT success wins all ties

    if (expiredTimestamp) {
      return { type: ResultStatus.TIMEOUT };
    } else {
      var isMounted = function isMounted(marker) {
        return checks[marker] && checks[marker].mounted;
      };

      var scenarios = Object.keys(routeSpec.success).filter(function (scenario) {
        return routeSpec.success[scenario].length && routeSpec.success[scenario].every(isMounted);
      });

      if (scenarios.length) {
        // TODO warn if multiple
        return { type: ResultStatus.SUCCESS, scenario: scenarios[0] };
      } else if (routeSpec.error.some(isMounted)) {
        return { type: ResultStatus.FAILURE };
      }
    }

    return { type: ResultStatus.PENDING };
  };

  var lastEntry = void 0;
  var lastResult = void 0;
  return function (entry) {
    if (lastEntry === entry) {
      return lastResult;
    }

    lastEntry = entry;
    lastResult = checkStatusImpl(entry);
    return lastResult;
  };
};

var buildReporter = function buildReporter(getRouteSpec, report) {
  var forActionType = function forActionType(type, entry, extra) {
    var pathname = entry.pathname;

    var routeSpec = getRouteSpec(pathname);
    var payload = {
      entry: entry,
      routeSpec: routeSpec
    };
    if (extra) {
      Object.assign(payload, { extra: extra });
    }
    return {
      type: type,
      payload: payload
    };
  };

  return function () {
    return report(forActionType.apply(undefined, arguments));
  };
};

var reducer = function reducer(prevState, action) {
  var prevEntry = prevState.entry,
      _prevState$entry = prevState.entry,
      prevPathname = _prevState$entry.pathname,
      prevId = _prevState$entry.id,
      prevChecks = _prevState$entry.checks,
      prevEntries = prevState.entries;


  switch (action.type) {
    case ActionTypes.HISTORY_CHANGED:
      {
        var _action$payload = action.payload,
            pathname = _action$payload.pathname,
            timestamp = _action$payload.timestamp;

        return pathname !== prevPathname ? _extends({}, prevState, {
          entry: {
            id: prevId + 1,
            pathname: pathname,
            referrer: prevPathname,
            timestamp: timestamp,
            checks: {}
          },
          entries: [].concat(_toConsumableArray(prevEntries), [prevEntry])
        }) : prevState;
      }
    case ActionTypes.MARKER_MOUNTED:
      {
        var _action$payload2 = action.payload,
            _action$payload2$mark = _action$payload2.marker,
            marker = _action$payload2$mark.name,
            id = _action$payload2$mark.id,
            _timestamp = _action$payload2.timestamp;

        // eslint-disable-next-line no-undef

        if (process.env.NODE_ENV !== 'production') {
          if (prevChecks[marker] && prevChecks[marker].mounted) {
            console.error('[react-rhumb] marker already rendered: "%s". Rendering duplicate markers is deprecated and route failure in the next version', marker);
          }
        }

        return prevId === id ? _extends({}, prevState, {
          entry: _extends({}, prevEntry, {
            dirty: true,
            checks: _extends({}, prevChecks, _defineProperty({}, marker, _extends({}, prevChecks[marker], {
              mounted: true,
              timestamp: _timestamp
            })))
          })
        }) : prevState;
      }
    case ActionTypes.MARKER_UNMOUNTED:
      {
        var _action$payload$marke = action.payload.marker,
            _marker = _action$payload$marke.name,
            _id = _action$payload$marke.id;

        return prevId === _id && prevChecks[_marker] && prevChecks[_marker].mounted ? _extends({}, prevState, {
          entry: _extends({}, prevEntry, {
            checks: _extends({}, prevChecks, _defineProperty({}, _marker, _extends({}, prevChecks[_marker], {
              mounted: false,
              timestamp: undefined
            })))
          })
        }) : prevState;
      }
    case ActionTypes.TIMEDOUT:
      {
        var _timestamp2 = action.payload.timestamp;

        return _extends({}, prevState, {
          entry: _extends({}, prevEntry, {
            expiredTimestamp: _timestamp2
          })
        });
      }
    default:
      throw new Error('unexpected action ' + action.type);
  }
};

var usePreventPropChange =
// eslint-disable-next-line no-undef
process.env.NODE_ENV !== 'production' ? function (props) {
  var propsRef = (0, _react.useRef)(props);
  (0, _react.useEffect)(function () {
    (0, _invariant2.default)(propsRef.current.config === props.config, '`config` should not change');
    (0, _invariant2.default)(propsRef.current.history === props.history, '`history` should not change');
    propsRef.current = props;
  }, [props]);
} : function () {};

var useHistoryEffect = function useHistoryEffect(history, callback) {
  var queue = (0, _react.useRef)([]);
  var flush = (0, _react.useRef)(null);
  var savedCallback = (0, _react.useRef)();

  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  });

  if (!flush.current) {
    var unlisten = history.listen(function (_ref2) {
      var pathname = _ref2.pathname;

      var timestamp = (0, _performanceNow2.default)();
      queue.current.push({
        pathname: pathname,
        timestamp: timestamp
      });
    });

    flush.current = function () {
      unlisten();
      queue.current.forEach(savedCallback.current);
      queue.current = [];
      flush.current = function () {};
    };
  }

  (0, _react.useEffect)(function () {
    flush.current();
    return history.listen(savedCallback.current);
  }, [history]);
};

var useNewRelicRouteTracking = function useNewRelicRouteTracking(history, getRouteSpec) {
  var pathname = history.pathname;

  var initialRouteSpec = useInitial(function () {
    return getRouteSpec(pathname);
  });

  var updateNewRelicRouteData = function updateNewRelicRouteData(routeSpec) {
    var route = routeSpec ? routeSpec.route : 'unknown-route';
    if (window.newrelic) {
      window.newrelic.setCurrentRouteName(route);
      window.newrelic.setCustomAttribute('route', route);
    }
  };

  (0, _react.useEffect)(function () {
    if (window.newrelic) {
      window.newrelic.setCustomAttribute('reactRhumbVersion', formatVersion(_legacyHubspotBenderContext.bender.depVersions['react-rhumb']));
      window.newrelic.setCustomAttribute('reaganVersion', 'react-rhumb');
    }
  }, []);

  (0, _react.useEffect)(function () {
    updateNewRelicRouteData(initialRouteSpec);
  }, [initialRouteSpec]);

  var handleHistoryChange = function handleHistoryChange(_ref3) {
    var nextPathname = _ref3.pathname;

    updateNewRelicRouteData(getRouteSpec(nextPathname));
  };

  useHistoryEffect(history, handleHistoryChange);
};

var RhumbProvider = function RhumbProvider(props) {
  usePreventPropChange(props);

  var history = props.history,
      historyPathname = props.history.pathname,
      config = props.config,
      defaultTimeout = props.defaultTimeout,
      children = props.children;


  var routeSpecs = (0, _react.useMemo)(function () {
    return buildRouteSpecs(config, defaultTimeout || Constants.DEFAULT_TIMEOUT);
  }, [config, defaultTimeout]);

  var initialState = (0, _react.useMemo)(function () {
    return {
      entry: {
        id: 0,
        pathname: historyPathname,
        referrer: undefined,
        timestamp: 0,
        checks: {},
        expiredTimestamp: null,
        changed: false
      },
      entries: []
    };
  }, [historyPathname]);

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var getRouteSpec = (0, _react.useMemo)(function () {
    return buildGetRouteSpec(routeSpecs);
  }, [routeSpecs]);

  useNewRelicRouteTracking(history, getRouteSpec);

  var handleHistoryChange = function handleHistoryChange(_ref4) {
    var timestamp = _ref4.timestamp,
        nextPathname = _ref4.pathname;

    (0, _Scheduler.runWithLowPriority)(function () {
      dispatch({
        type: ActionTypes.HISTORY_CHANGED,
        payload: {
          pathname: nextPathname,
          timestamp: timestamp
        }
      });
    });
  };

  useHistoryEffect(history, handleHistoryChange);

  var reaganReporter = useInitial(function () {
    return (0, _reaganCompatReporter.reaganCompatReporter)(window.newrelic);
  });

  var report = (0, _react.useMemo)(function () {
    var debug = _enviro2.default.debug('react-rhumb') === 'true';

    return buildReporter(getRouteSpec, function (action) {
      if (debug) {
        (0, _consoleReporter2.default)(action);
      }

      reaganReporter(action);
    });
  }, [getRouteSpec, reaganReporter]);

  var checkStatus = (0, _react.useMemo)(function () {
    return buildCheckStatus(getRouteSpec);
  }, [getRouteSpec]);

  var timeoutRef = (0, _react.useRef)(null);

  var prevState = usePrevious(state);

  (0, _react.useEffect)(function () {
    var handleTimeout = function handleTimeout() {
      var timestamp = (0, _performanceNow2.default)();

      (0, _Scheduler.runWithLowPriority)(function () {
        dispatch({
          type: ActionTypes.TIMEDOUT,
          payload: {
            timestamp: timestamp
          }
        });
      });
    };

    var reportForStatus = function reportForStatus(status, entry) {
      switch (status.type) {
        case ResultStatus.SUCCESS:
          {
            var scenario = status.scenario;

            report(ReporterActionTypes.ROUTE_SUCCEEDED, entry, { scenario: scenario });
            break;
          }
        case ResultStatus.TIMEOUT:
          report(ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED, entry);
          break;
        case ResultStatus.FAILURE:
          report(ReporterActionTypes.ROUTE_FAILED, entry);
          break;
        default:
          throw new Error('unexpected status type ' + status.type);
      }
    };

    // there are new history entries
    if (prevState && state.entries !== prevState.entries) {
      var prevEntry = prevState.entry,
          prevChecks = prevState.entry.checks,
          prevEntries = prevState.entries;
      var currentEntries = state.entries;

      // clear the timeout

      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;

      //run through special cases

      var _currentEntries$slice = currentEntries.slice(prevEntries.length - currentEntries.length),
          _currentEntries$slice2 = _toArray(_currentEntries$slice),
          trailingEntry = _currentEntries$slice2[0],
          skippedEntries = _currentEntries$slice2.slice(1);

      var trailingPathname = trailingEntry.pathname,
          trailingChecks = trailingEntry.checks;

      var trailingRouteSpec = getRouteSpec(trailingPathname);

      if (trailingRouteSpec) {
        if (trailingChecks !== prevChecks) {
          report(ReporterActionTypes.CHECKS_CHANGED, trailingEntry);
        }

        var status = checkStatus(trailingEntry);
        if (trailingEntry !== prevEntry) {
          // the previous entry changed during the last batch of updates and should be checked
          if (status.type !== ResultStatus.PENDING) {
            reportForStatus(status, trailingEntry);
          } else {
            report(ReporterActionTypes.ROUTE_ABANDONED, trailingEntry);
          }
        } else {
          if (status.type === ResultStatus.PENDING) {
            report(ReporterActionTypes.ROUTE_ABANDONED, trailingEntry);
          }
        }
      }

      // entries that were added between updates
      // nothing should ever have been mounted in these entries
      skippedEntries.forEach(function (skippedEntry) {
        var skippedPathname = skippedEntry.pathname;

        var skippedRouteSpec = getRouteSpec(skippedPathname);

        if (skippedRouteSpec) {
          report(ReporterActionTypes.ROUTE_STARTED, skippedEntry);
          report(ReporterActionTypes.ROUTE_ABANDONED, skippedEntry);
        } else {
          report(ReporterActionTypes.ROUTE_UNEXPECTED, skippedEntry);
        }
      });
    }

    // check the new entry
    if (!prevState || prevState.entries !== state.entries) {
      var currentEntry = state.entry,
          _state$entry = state.entry,
          currentPathname = _state$entry.pathname,
          currentDirty = _state$entry.dirty;

      var routeSpec = getRouteSpec(currentPathname);

      if (routeSpec) {
        report(ReporterActionTypes.ROUTE_STARTED, currentEntry);

        if (currentDirty) {
          // TODO can this ever be hit?
          report(ReporterActionTypes.CHECKS_CHANGED, currentEntry);
        }

        var _status = checkStatus(currentEntry);
        if (_status.type !== ResultStatus.PENDING) {
          // TODO can this ever be hit?
          reportForStatus(_status, currentEntry);
        } else {
          var timeout = routeSpec.timeout;

          timeoutRef.current = setTimeout(handleTimeout, timeout);
        }
      } else {
        report(ReporterActionTypes.ROUTE_UNEXPECTED, currentEntry);
      }
    }

    // there are no new history entries but existing entry has some changes and needs to be checked
    if (prevState && prevState.entries === state.entries && prevState.entry !== state.entry) {
      var _prevChecks = prevState.entry.checks;
      var _currentEntry = state.entry,
          _state$entry2 = state.entry,
          _currentChecks = _state$entry2.checks,
          _currentPathname = _state$entry2.pathname;

      var _routeSpec = getRouteSpec(_currentPathname);

      if (_routeSpec) {
        if (_currentChecks !== _prevChecks) {
          report(ReporterActionTypes.CHECKS_CHANGED, _currentEntry);
        }

        var _status2 = checkStatus(_currentEntry);
        if (_status2.type !== ResultStatus.PENDING) {
          reportForStatus(_status2, _currentEntry);

          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
      }
    }
  }, [prevState, state, getRouteSpec, checkStatus, report]);

  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    };
  }, []);

  var _state$entry3 = state.entry,
      currentChecks = _state$entry3.checks,
      currentId = _state$entry3.id;


  var visibleMarkers = (0, _react.useMemo)(function () {
    return Object.keys(currentChecks).filter(function (marker) {
      return currentChecks[marker].mounted;
    });
  }, [currentChecks]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      id: currentId,
      dispatch: dispatch
    };
  }, [currentId]);

  var visibleMarkersData = (0, _react.useMemo)(function () {
    return visibleMarkers.map(encodeURIComponent).join(',');
  }, [visibleMarkers]);

  return _react2.default.createElement(
    _RhumbContext2.default.Provider,
    { value: contextValue },
    children || null,
    _react2.default.createElement(
      'div',
      {
        hidden: true,
        'aria-hidden': 'true',
        'data-id-markers': visibleMarkersData
      },
      visibleMarkers.map(function (marker) {
        return _react2.default.createElement('mark', { key: marker, 'data-id-marker': marker });
      })
    )
  );
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  RhumbProvider.propTypes = {
    config: _propTypes2.default.shape({}).isRequired,
    history: _propTypes2.default.shape({
      listen: _propTypes2.default.func.isRequired,
      pathname: _propTypes2.default.string.isRequired
    }).isRequired,
    children: _propTypes2.default.node,
    defaultTimeout: _propTypes2.default.number
  };
}

exports.default = _react2.default.memo(RhumbProvider);
module.exports = exports['default'];